import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-selected",
  "use": "icon-selected-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-selected\"><defs><style type=\"text/css\"></style></defs><path d=\"M960 0a64 64 0 0 1 64 64v896a64 64 0 0 1-64 64H64a64 64 0 0 1-64-64V64a64 64 0 0 1 64-64h896z m-133.12 323.52a48 48 0 0 0-67.904 0L453.44 628.992 329.024 504.576a48 48 0 1 0-67.84 67.84l158.336 158.4a48 48 0 0 0 67.904 0l339.392-339.392a48 48 0 0 0 0-67.84z\" p-id=\"7754\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol